<template>
  <div class="maxbox">
    <div>
      <div class="top">
        <p>我的资产</p>
      </div>
      <div class="main">
        <button @click="goback" class="return">
          <img src="@/assets/images/left-arrow.png" alt="返回">
        </button>
        <div class="main-content">
          <div class="info-row">
            <span>累计总收益</span>
            <span>{{ totalRewards }} TND</span>
          </div>
          <div class="info-row">
            <span>持有矿机总数</span>
            <span>{{ totalMachineNum }} 台</span>
          </div>
          <div class="info-row">
            <span>矿机总分红</span>
            <span>{{ machineTotalEarn }} TND</span>
          </div>
          <div class="info-row">
            <span>一代推荐奖金</span>
            <span>{{ firstLevelBonus }} TND</span>
          </div>
          <div class="info-row">
            <span>二代推荐奖金</span>
            <span>{{ secondLevelBonus }} TND</span>
          </div>
          <div class="info-row">
            <span>3-10代团队奖金</span>
            <span>{{ thirdToTenthLevelBonus }} TND</span>
          </div>
          <div class="info-row highlight">
            <span>可提现余额</span>
            <span>{{ withdrawableDividends }} TND</span>
          </div>
          <input type="number" v-model="amountToWithdraw" placeholder="输入提现金额" class="withdraw-input">
          <button @click="withdrawDividends" class="withdraw-button">立即提现</button><br>
          <h3 @click="goToShouyi">分红明细(点击查看更多)</h3>
          <div class="dividends-scrollable" style="height: 300px; max-height: 300px;overflow-y:auto;">
            <ul class="dividend-list">
              
              <li v-for="(item, index) in allDividendList" :key="item.time + index" class="dividend-item">
                <span>
                  {{ item.type }}
                  <span v-if="item.showFrom" style="font-size:12px;color:#888;margin-left:6px;">
                    来自：{{ shortAddress(item.fromMember) }}
                  </span>
                  <span style="font-size:12px;margin-left:4px;color:#aaa;">
                    {{ item.date }}
                  </span>
                </span>
                <span class="dividend-amount">{{ item.amount }} TND</span>
              </li>
              <li v-if="allDividendList.length === 0" class="dividend-item" style="justify-content:center;color:#999">
                暂无分红记录（子图存在索引延迟）
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { ethers } from 'ethers';
import { contractAddress, contractABI } from '@/js/contract.js';
const DECIMAL = 6;
const ZERO_BN = ethers.BigNumber.from(0)
const GRAPH_URL = "https://gateway.thegraph.com/api/subgraphs/id/C95kzECu3rd3igQsGfTW6hN11Tw37hp9RyDsVdiMmpGx"
export default {
  name: 'income',
  data() {
    return {
      totalRewards: '0.000000',
      totalMachineNum: 0,
      machineTotalEarn: '0.000000',
      firstLevelBonus: '0.000000',
      secondLevelBonus: '0.000000',
      thirdToTenthLevelBonus: '0.000000',
      withdrawableDividends: '0.000000',
      amountToWithdraw: '',
      allDividendList: [],
      userAddr: ""
    }
  },
  methods: {
    goToShouyi() {
      this.$router.push('/shouyi')
    },
    goback() {
      this.$router.go(-1);
    },
    async connectWallet() {
      if (!window.ethereum) return null;
      try {
        await window.ethereum.request({ method: 'eth_requestAccounts' });
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        return provider;
      } catch (e) {
        return null;
      }
    },
    formatSix(v) {
      return ethers.utils.formatUnits(v?.toString() || '0', DECIMAL)
    },
    calcMineEarn(total, l1, l2, l3) {
      const totalBn = ethers.BigNumber.from(total || 0);
      const b1 = ethers.BigNumber.from(l1 || 0);
      const b2 = ethers.BigNumber.from(l2 || 0);
      const b3 = ethers.BigNumber.from(l3 || 0);
      let mine = totalBn.sub(b1).sub(b2).sub(b3);
      if (mine.lt(0)) mine = ethers.BigNumber.from(0);
      return this.formatSix(mine);
    },
    async getUserBonuses() {
      const provider = await this.connectWallet();
      if (!provider) return;
      const signer = provider.getSigner();
      this.userAddr = (await signer.getAddress()).toLowerCase();
      const contract = new ethers.Contract(contractAddress, contractABI, signer);
      try {
        const totalDividends = await contract.getTotalDividends();
        const machineInfo = await contract.getMemberMachines(this.userAddr);
        const first = await contract.getFirstLevelBonus();
        const second = await contract.getSecondLevelBonus();
        const third = await contract.getThirdToTenthLevelBonus();
        const withdraw = await contract.getWithdrawableDividends();
        this.totalRewards = this.formatSix(totalDividends);
        this.totalMachineNum = Number(machineInfo[0]) || 0;
        this.firstLevelBonus = this.formatSix(first);
        this.secondLevelBonus = this.formatSix(second);
        this.thirdToTenthLevelBonus = this.formatSix(third);
        this.withdrawableDividends = this.formatSix(withdraw);
        this.machineTotalEarn = this.calcMineEarn(totalDividends, first, second, third);
      } catch (error) {
        console.error("查询资产失败", error);
      }
    },
    // 修复：分页循环拉取全部矿机、推荐事件，不会截断数据
   // 修复：分页循环拉取全部矿机、推荐事件，不会截断数据 + 适配正式网关鉴权+地址格式
async getDividendLogs() {
  if (!this.userAddr) return;
  try {
    const allMine = []
    const allRefer = []
    let skipMine = 0
    let skipRefer = 0
    const pageSize = 1000
    // 正式网关强制鉴权Header
    const authHeaders = {
      "Content-Type": "application/json",
      "Authorization": "Bearer 8f9c604fdd39444789841cbead617821"
    }
    // 循环拉取全部矿机奖励
    while (true) {
      const mineQuery = `
        query Mine($user: Bytes!, $skip: Int!) {
          mineRewardRecords(where:{user:$user},orderBy:settleTimestamp,orderDirection:desc,first:1000,skip:$skip) {
            user
            amount
            settleTimestamp
            settleRoundId
          }
        }
      `
      const res = await fetch(GRAPH_URL, {
        method: 'POST',
        headers: authHeaders,
        body: JSON.stringify({ 
          query: mineQuery, 
          // 切掉0x前缀，适配Bytes类型
          variables: { user: this.userAddr.slice(2), skip: skipMine } 
        })
      })
      const json = await res.json()
      if (!json?.data?.mineRewardRecords) {
        console.error("矿机明细查询异常", json.errors, json)
        break
      }
      const list = json.data.mineRewardRecords
      if (list.length === 0) break
      allMine.push(...list)
      skipMine += pageSize
      if (skipMine > 100000) break
    }
    // 循环拉取全部推荐奖励
    while (true) {
      const referQuery = `
        query Refer($user: Bytes!, $skip: Int!) {
          referralRewardRecords(where:{receiver:$user},orderBy:settleTimestamp,orderDirection:desc,first:1000,skip:$skip) {
            receiver
            fromUser
            level
            amount
            settleTimestamp
            settleRoundId
          }
        }
      `
      const res = await fetch(GRAPH_URL, {
        method: 'POST',
        headers: authHeaders,
        body: JSON.stringify({ 
          query: referQuery, 
          variables: { user: this.userAddr.slice(2), skip: skipRefer } 
        })
      })
      const json = await res.json()
      if (!json?.data?.referralRewardRecords) {
        console.error("推荐明细查询异常", json.errors, json)
        break
      }
      const list = json.data.referralRewardRecords
      if (list.length === 0) break
      allRefer.push(...list)
      skipRefer += pageSize
      if (skipRefer > 100000) break
    }
    // 组装列表 原有逻辑完全不变
    let tempList = [];
    for (const m of allMine) {
      tempList.push({
        type: "矿机分红",
        fromMember: null,
        showFrom: false,
        amount: this.formatSix(m.amount),
        date: this.formatTime(m.settleTimestamp),
        time: Number(m.settleTimestamp)
      })
    }
    for (const r of allRefer) {
      let typeName = ""
      const lv = Number(r.level)
      if (lv === 1) typeName = "一代推荐分红"
      else if (lv === 2) typeName = "二代推荐分红"
      else typeName = "3-10级团队分红"
      tempList.push({
        type: typeName,
        fromMember: r.fromUser,
        showFrom: true,
        amount: this.formatSix(r.amount),
        date: this.formatTime(r.settleTimestamp),
        time: Number(r.settleTimestamp)
      })
    }
    // 全局时间倒序
    tempList.sort((a, b) => b.time - a.time)
    this.allDividendList = tempList
  } catch (e) {
    console.error("Graph读取分红明细失败", e)
    this.allDividendList = []
  }
},

    formatTime(timestamp) {
      if (!timestamp) return "";
      const d = new Date(Number(timestamp) * 1000);
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${d.getFullYear()}-${m}-${day}`;
    },
    shortAddress(addr) {
      if (!addr || addr === ethers.constants.AddressZero) return "";
      return addr.slice(0, 6) + "..." + addr.slice(-4);
    },
    async withdrawDividends() {
      if (!this.amountToWithdraw || Number(this.amountToWithdraw) <= 0) {
        alert("请输入正确提现金额");
        return;
      }
      const provider = await this.connectWallet();
      if (!provider) return;
      const signer = provider.getSigner();
      const contract = new ethers.Contract(contractAddress, contractABI, signer);
      try {
        const amountInWei = ethers.utils.parseUnits(this.amountToWithdraw.toString(), DECIMAL);
        const tx = await contract.withdrawDividends(amountInWei);
        await tx.wait();
        alert("提现交易提交成功！");
        this.amountToWithdraw = '';
        await this.getUserBonuses();
        this.getDividendLogs().catch(err => {
          console.error("分红列表刷新异常，不影响余额", err);
        });
      } catch (e) {
        alert("提现失败，请检查余额或网络");
        console.log("提现错误：", e)
      }
    }
  },
  async mounted() {
    await this.getUserBonuses();
    await this.getDividendLogs();
  }
}
</script>
<style scoped>
@import "@/assets/css/style.css";
@import "@/assets/css/detill.css";
.info-row {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  font-size: 16px;
}
.info-row.highlight span:last-child {
  color: #007AFF;
  font-weight: bold;
}
.dividends-scrollable {
  height: 360px;
  overflow-y: auto;
}
.main-content h3 {
  position: sticky;
  top: 0;
  background-color: #eee;
  z-index: 1;
  margin: 4px 0 8px 0;
  border-radius: 4px;
  cursor: pointer;
  height: 32px;
  line-height: 32px;
  padding-left:10px;
}
.main {
  padding-top: 30px;
}
.dividend-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.dividend-item {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 14px;
  border-bottom: 1px dashed #eee;
}
.dividend-amount {
  font-weight: 500;
}
.withdraw-input{
  width: 100%;
  padding: 10px;
  margin:10px 0;
  border:1px solid #ccc;
  border-radius:6px;
  box-sizing: border-box;
}
.withdraw-button{
  width:100%;
  padding:12px;
  background:#007AFF;
  color:#fff;
  border:none;
  border-radius:6px;
  font-size:16px;
}
</style>
